<template>
  <div class="app-container">
    <el-form :model="formInline" label-width="100px">
      <el-row>
        <el-col :xs="16" :sm="8" :md="6" :lg="6" :xl="6">
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="formInline.time"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="onChangeTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item  label="事件类型">
              <el-select :style="{width:'100%'}" clearable v-model="formInline.parkEventType">
                  <el-option
                          v-for="item in monitorLabel"
                          :label="item.itemName"
                          :value="item.itemCode"
                          :key="item.itemCode">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item  label="套餐类型">
              <el-select :style="{width:'100%'}" clearable v-model="formInline.setmealNo">
                  <el-option
                          v-for="item in setmealNoLabel"
                          :label="item.itemName"
                          :value="item.itemCode"
                          :key="item.itemCode">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label-width="150px" label="进场时间范围（分）">
              <el-input v-model="formInline.min" maxlength="3" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="16" :sm="8" :md="6" :lg="6" :xl="6">
          <el-form-item label-width="20px">
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">
              查询
            </el-button>
            <el-button
              type="primary"
              @click="onDownload"
              icon="el-icon-download"
              :disabled="multipleSelection.length < 1"
            >
              导出
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column prop="inDeviceName" label="入场设备名"></el-table-column>
      <el-table-column prop="outDeviceName" label="出场设备名"></el-table-column>
      <el-table-column prop="inTime" label="进场时间"> </el-table-column>
      <el-table-column prop="outTime" label="出场时间"> </el-table-column>
      <el-table-column prop="plateNumber" label="车牌号"> </el-table-column>
      <el-table-column prop="parkEventTypeName" label="事件类型"> </el-table-column>
      <el-table-column prop="plateColor" label="车辆颜色"></el-table-column>
      <el-table-column prop="sealName" label="套餐名称"> </el-table-column>
      <el-table-column prop="stationOperator" label="操作员"> </el-table-column>
      
    </el-table>
    <div class="block" style="margin-top: 15px">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { parkingAreaRecordFirstNew } from '@/api/business/beijing/door'
import { getLoopUpItem } from '@/api/business/base/tenant/device'

export default {
  data() {
    return {
      formInline: {
        type: 0,
        time: [this.$moment(new Date()).format('YYYY-MM-DD'), this.$moment(new Date()).format('YYYY-MM-DD')],
        parkEventType: null,
        setmealNo: null,
        min: null,
      },
      // 今日人流量
      todayTotal: 0,
      timeOptionRange: '',
      pickerOptions: {
        onPick: time => {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: time => {
          let timeOptionRange = this.timeOptionRange
          let secondNum = 60 * 60 * 24 * 1000
          if (timeOptionRange) {
            // if ((timeOptionRange.getTime() + secondNum) > (Date.now() - 8.64e6)) {
            //   return time.getTime() > Date.now() - 8.64e6 || time.getTime() < timeOptionRange.getTime() - secondNum
            // }
            return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum
          }
        },
      },
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 20, // 每页的数据条数
      // 表格数据
      tableData: [],
      tableSumData: [],
      // 选中列表
      multipleSelection: [],
      loading: false,
      dataList: [],
      monitorLabel: [],
      setmealNoLabel: []
    }
  },
  computed: {
    routeQuery() {
      return this.$route.query.queryPark
    }
  },
  watch: {
    routeQuery() {
      this.onSubmit()
    }
  },
  created() {
    this.onSubmit()
    this.getMonitorLabel();
    this.getSetmealNoLabel();
  },
  methods: {
    getMonitorLabel() {
        getLoopUpItem({"classifyCode":"park_event_type"}).then(res=>{
            this.monitorLabel = res;
        });
    },
    getSetmealNoLabel() {
        getLoopUpItem({"classifyCode":"setmealNo"}).then(res=>{
            this.setmealNoLabel = res;
        });
    },
    // 提交查询
    onSubmit() {
      this.currentPage = 1
      if (!this.formInline.time) {
        this.formInline.time = [this.$moment(new Date()).format('YYYY-MM-DD'), this.$moment(new Date()).format('YYYY-MM-DD')]
      }
      const params = {
        startDate: this.formInline.time[0],
        endDate: this.formInline.time[1],
        queryArea: this.$route.query.queryArea,
        parkEventType: this.formInline.parkEventType,
        setmealNo: this.formInline.setmealNo,
        min: this.formInline.min
      }
      this.loading = true
      parkingAreaRecordFirstNew(params).then(res => {
        this.total = res.dataList.length
        this.dataList = res.dataList
        this.tableData = this.dataList.slice(0, 20)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 表格下载
    onDownload() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../../../public/Export2Excel')
        // filterVal内容是json中的键
        let filterVal = ["inDeviceName","outDeviceName", "inTime", "outTime", "plateNumber", "plateColor", "sealName", "stationOperator"]
        // tHeader内容是excel中的第一行
        let tHeader = ["入场设备名", "出场设备名", "进场时间", "出场时间", "车牌号", "车辆颜色", "套餐名称", "操作员"]
        const list = this.multipleSelection // json 数据
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, "停车场记录表格")
      })
    },
    // 格式化JSON数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 列表选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 时间格式计算
    onChangeTime(value) {
      if (value && value[0] === value[1]) {
        this.formInline.time[0] = value[0]
        this.formInline.time[1] = this.$moment(new Date(value[1])).format('YYYY-MM-DD 23:59:59')
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      const start = (val - 1) * 20
      const end = (val - 1) * 20 + 20 > this.dataList.length ? this.dataList.length : (val - 1) * 20 + 20
      this.tableData = this.dataList.slice(start, end)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 100%;
}
.el-date-editor--daterange.el-input__inner {
  width: 100%;
}
</style>